import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AudioPlayerService } from '../../_services/audio-player.service';
import { AudioTrackStoreService } from '../../_services/audio-track-store.service';

@Component({
  selector: 'app-song-control',
  templateUrl: './song-control.component.html',
  styleUrls: ['./song-control.component.css']
})
export class SongControlComponent implements OnInit, OnDestroy {

  isPlaying: boolean;
  value = 0;
  duration = 0;
  step = 'any';

  @Input() public track: any;

  playSub: Subscription;
  endedSub: Subscription;
  timeUpdateSub: Subscription;

  constructor(private playerService: AudioPlayerService, private audioStore: AudioTrackStoreService) {
    this.playSub = playerService.playTrack$.subscribe(track => {
      this.isPlaying = false;
    });

    this.endedSub = playerService.trackEnded$.subscribe(() => {
      this.isPlaying = false;
    });
  }

  ngOnInit(): void {
    this.isPlaying = this.track.trackUrl === this.audioStore.trackUrl;
    this.duration = this.timeToSecconds(this.track.duration);
    this.timeUpdateSub = this.playerService.timeUpdate$.subscribe(state => {
      if (state.currentSrc === this.track.trackUrl) {
        this.value = state.currentTime;
      }
    });
  }

  ngOnDestroy(): void {
    this.playSub.unsubscribe();
    this.endedSub.unsubscribe();
    this.timeUpdateSub.unsubscribe();
  }

  playTrack() {
    this.playerService.playTrack(this.track.trackUrl);
    this.isPlaying = true;
    this.audioStore.trackUrl = this.track.trackUrl;
  }

  pauseTrack() {
    this.playerService.pauseTrack();
    this.isPlaying = false;
    this.audioStore.trackUrl = '';
  }

  seekTime(event) {
    this.playerService.currentTimeUpdate(event.target.value);
  }

  timeToSecconds(hms: string): number {
    const a = hms.split(':'); // split it at the colons

    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);

    return seconds;
  }
}
